/**
 * author: lingyb@jpush.cn
 * desc: Pipe，可以把html解析出来而不被angular过滤掉
 */
export * from './safe-html.module';
